import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '../../services/api.service';
import { Observable } from 'rxjs';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToasterModule, ToasterService } from 'angular2-toaster';

@Component({
	selector: 'app-import',
	templateUrl: './import.component.html',
	styleUrls: ['./import.component.css']
})

export class ImportComponent implements OnInit {

	import: FormGroup;
	file: File;
	submitted: boolean = false;
	size: number;

	public companies: Array<any>;

	constructor(private apiService: ApiService, private router: Router, private fb: FormBuilder, private toasterService: ToasterService) {		
		this.import = this.fb.group({
			userName: new FormControl('', Validators.required),
			// firstName: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z]*$')])
		});
	}

	ngOnInit() {
		let params:any = {
			skip: 0,
			limit: 0,
			name:''
		}
		this.apiService.getAllCompanies(params).subscribe((data:any) => {
			this.companies = data.data.companyData;
		},
		error => {			
			if(error.statusText ==  "Unauthorized") {
				// this.toasterService.pop('error', 'Session Expired', 'Please login again');
				window.open("/logout", "_self");
			} else
			 this.toasterService.pop('error', error.error.message);
		});
	}

	back() {
		this.router.navigate(['/managers']);
	}

	fileSelected(imageData) {
		this.size = imageData.size;
		if (imageData.size > 3072000) {
			this.toasterService.pop('error', 'Payload content length greater than maximum allowed: 3MB', 'Error');
		} else {
			this.file = imageData;
		}
	}

	AdminAddManager() {
		if (this.import.valid) {
			this.submitted = true;

			let formData: FormData = new FormData();
			formData.append('userName', this.import.value.userName);
			formData.append('firstName', this.import.value.firstName);

			if (this.file) {
				formData.append('profilePic', this.file);
			}
			
			// this.apiService.addManager(formData).subscribe((data:any) =>{
			// 	this.submitted = false;
			// 	this.toasterService.pop('success', data.message);
			// 	this.back();
			// },
			// error => {
			// 	this.submitted = false;
			// 	this.toasterService.pop('error', JSON.parse(error._body).message, JSON.parse(error._body).error);
			// });
		}
	}

}



// WEBPACK FOOTER //
// ./src/app/components/import/import.component.ts